<template>
  <div class="component-score-box">
    <!-- //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题 -->
    <!-- 所有题型不需要题号高度留白 -->
    <template v-if="isPreview">
      <span v-if="msg.hasTitle" :title="msg.name">
        <span v-if="msg.editName">
          {{ msg.editName }}
        </span>
        <span v-else>
          {{
            `${msg.th}、${msg.name && msg.name.substr(0, 38)}${
              msg.name && msg.name.length > 38 ? "..." : ""
            }`
          }}
          <span class="score" v-if="!answerSheet.acCardHideScore"
            >（{{
              parseInt(msg.totalScore) == msg.totalScore
                ? msg.totalScore
                : (String((msg.totalScore && msg.totalScore.toFixed(1))).split(".")[1] == "0"
                    ? String((msg.totalScore && msg.totalScore.toFixed(1))).split(".")[0]
                    : (msg.totalScore && msg.totalScore.toFixed(1))) || 2
            }}分）</span
          >
        </span>
      </span>
      <span v-else></span>
    </template>
    <template v-else>
      <span v-if="msg.hasTitle" :title="msg.name">
        <el-input
          v-model="scoreValue"
          :maxlength="answerSheet.acCardPanes == 3 ? 35 : 52"
          placeholder="请输入内容"
          @blur="handlerBlur"
          @focus="handlerFocus"
          class="title_input"
        ></el-input>
      </span>
    </template>
    <div
      v-if="showScoreBox && msg.type != 2 && !msg.eachBlankScore"
      class="score-box"
      :data-th="setData"
      :class="{'score-df': answerSheet.acCardYJType == 2}"
      :style="`top:${msg.hasTitle ? '41px' : '.5px'}`"
    >
      <div class="score-con" v-if="answerSheet.acCardYJType == 2">
        <span class="score-cell" v-for="(item ,index) in scoreArray" :key="index">
          {{ item != -1 ? item : '' }}
        </span>
        <span></span>
      </div>
      <div v-else class="s-text">
        得
        <br />分
      </div>
    </div>
  </div>
</template>

<script>
//  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
import { mapState, mapGetters, mapMutations } from "vuex";
import { editScoreBoxMixins } from "../../../mixins/editScoreBox.mixins";
import { PAGE_SIZE_CELL } from '@/subjects/constant'
import { AnswerModel } from '@/subjects/answer/Answer.model';
export default {
  props: ["msg", "isPreview"],
  mixins: [editScoreBoxMixins],
  computed: {
    ...mapState("answerPanel", {
      answerSheet: (state) => state.answerSheet,
    }),
    ...mapState("card", {
      subjects: (state) => state.subjects,
    }),
    showScoreBox() {
      let result = false;
      if(this.answerSheet.acCardYJType == 0 || this.answerSheet.acCardYJType == 2) {
        result = true;
        if( this.msg.type != 3 && !this.msg.hasTitle) {
          result = false;
        } else if ( this.msg.type == 3 && this.msg.isSub ) {
          result = false;
        } else if (this.msg.type == 2) {
          result = false;
        } 
       
      }
      return result;
    },
    setData: function () {
      const chineseNumMap = { 
        '一': 1, '二': 2, '三': 3,'四': 4,'五': 5,'六':6,'七':7,'八':8,'九':9,'十':10 ,
        '十一':11,'十二':12,'十三':13,'十四':14,'十五':15,'十六':16,'十七':17,'十八':18,'十九':19,'二十':20,
        '二十一':21,'二十二':22,'二十三':23,'二十四':24,'二十五':25,'二十六':26,'二十七':27,'二十八':28,'二十九':29,'三十':30 
      };
      //const th = chineseNumMap[this.msg.th];
      const th = chineseNumMap[this.msg.th];
      if (this.msg.no) return th + '.' + this.msg.no;
      else return th;
    },
  },
  data() {
    return {
      scoreValue: "",
      scoreArray: []
    };
  },
  methods: {
    initScoreBox(target, type) {
      let topicName = `${target.th}、${
        target.name && target.name.substr(0, 38)
      }${target.name && target.name.length > 38 ? "..." : ""}`;
      if (target.editName) {
        // editName不为undefined的话 则嗲表用户编辑过标题并且保存了则优先展示editName
        this.scoreValue = target.editName;
      } else {
        if (!this.answerSheet.acCardHideScore) {
          this.scoreValue = this.msg.showScore == '0' ? topicName :
            topicName +
            "（" +
            (parseInt(target.totalScore) == target.totalScore
              ? target.totalScore
              : (String(target.totalScore && target.totalScore.toFixed(2)).split(".")[1] == "00"
                  ? String(target.totalScore && target.totalScore.toFixed(2)).split(".")[0]
                  : target.totalScore && target.totalScore.toFixed(2)) || 2) +
            "分）";
        } else {
          this.scoreValue = topicName;
        }
      }
    },
    handlerBlur(val) {
      this.$emit("myBlur", val.target.value);
    },
    handlerScore(msg){
      // console.log('handlerScore===',msg,this.subjects);
      if(msg){
        let  scoreArray  = []
        if( msg.type == 3 ){
          let objs = this.subjects.filter(model => model.type ==3 )
          for (let index = 0; index < objs.length; index++) {
            const element = objs[index];
            if(element.items){
              let io  = element.items.find(i => i.no == msg.no)
              scoreArray = io ? this.getNumUnit(io.score) : []
              if(io) break
            }
          }
        }else {
         scoreArray =  this.getNumUnit(msg.totalScore)
        }
        this.scoreArray = [...scoreArray]
      }
    },
    getNumUnit(number) {
      const numStr = number ? number.toString() : '';
      // 分割整数部分和小数部分
      const parts = numStr.split(".");
      const point = parts.length > 1 ? parts[1] : "";

      let hundred = Math.floor((number / 100) % 10);
      let ten = Math.floor((number / 10) % 10);
      let one = Math.floor(number % 10);
      let hundreds = number == 0 ? [] : this.numSplit(hundred);
      let tens =  number == 0 ? [] : this.numSplit(ten);
      let ones =  number == 0 ? [] : this.numSplit(one,true,ten);
      //小数点
      let points = number == 0 ? [] : [0, 0.5, -1];
      let socreArr = [].concat(points, ones, tens, hundreds);
      //
      let width = this.answerSheet.acCardPanes == 3 ? PAGE_SIZE_CELL[1] : PAGE_SIZE_CELL[0];
      let scoreSpan = Math.floor((width - 33) / 32);
      let scoreArray = [];
      for (let index = scoreSpan; index >= 0; index--) {
        if (index < socreArr.length) {
          scoreArray.push(socreArr[index]);
        } else {
          scoreArray.push(-1);
        }
      }
      // this.scoreArray = [...scoreArray];
      return scoreArray
    },
    numSplit(number,isOnes, preNumber) {
      let arr = [];
      if(isOnes ){
        if (number == 0 && (preNumber == 0 || !preNumber) ) return [];
        let maxNumber = preNumber >= 0 ? 9 : number
          for (let index = 0; index <= maxNumber; index++) {
            arr.push(index);
          }
        return arr
      }
      //
      if (number == 0) return [];
      for (let index = 0; index <= number; index++) {
        arr.push(index);
      }
      number > 0 && arr.unshift(-1);
      return arr;
    },
  },
  watch: {
    msg: {
      handler(newVal) {
        this.initScoreBox(newVal);
        // console.log('newVal====',newVal, this.subjects, this.pageCell);
        this.handlerScore(newVal);
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.initScoreBox(this.msg);

    // this.handlerScore(this.msg)
  },
};
</script>

<style lang='scss' >
.component-score-box {
  position: relative;
}
.score-box {
  position: absolute;
  display: flex;
  right: 1px;
  top: 41px;
  width: 85px;
  height: 34px;
  box-sizing: border-box;
  border: 1px solid #000;
  z-index: 999;
  border-top: none;
  border-right: none;
  background: #fff;
  opacity: 0.8;
  font-size: 12px;
  border-bottom: none;
  text-align: center;
  line-height: 31px;
}
.score-df {
   width:100% !important;
    position: initial !important;
    /* border-right: 1px solid #000 !important; */
    border-bottom: none !important;
    border-left: none !important;
}
.score-con {
  display: flex;
  width: 100%;
}
.score-cell {
   position: relative;
    float: left;
    width: 6.66%;
    height: 30px;
    border: 1px solid #000;
    border-left: none;
    &:first-child {
      border-left: 1px solid #000;
    }
    &:last-child {
      width: 32px;
    }
}
.score-box .s-text {
  padding: 0 3px;
  line-height: 16px;
  border-right: 1px solid #000;
}
.title_input input {
  border:1px solid transparent !important;
  border-radius: 0px !important;
  box-sizing: border-box;
}
.title_input input:hover {
  border: 1px solid #4891ff !important;
  border-bottom:1px solid transparent !important;
}
.component-score-box .el-input__inner{
  color: #000;
  padding: 0 !important;
}
</style>